import BossModel from "@/models/BossModel";
import { saveAs } from 'file-saver';

export default class File extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'file';

    /**
     *
     * @type {string}
     */
    static entity = 'files';

    static fields() {
		return {
			id: this.number(null).nullable(),
			filename: this.attr(null),
			original_filename: this.attr(null),
            public: this.attr(null),
            old_path: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			path: this.attr(null),
		}
	}

    download(fileName = this.original_filename) {
        return this.constructor.api().action(this.id + '/download').getBlob().then(response => {
            return saveAs(response, fileName);
        });
    }

    static downloadById(id, fileName) {
        return this.api().action(id + '/download').getBlob().then(response => {
            return saveAs(response, fileName);
        });
    }

    static async blobById(id) {
        return await this.api().action(id + '/download').getBlob();
    }

    open(fileType = 'application/pdf') {
        return this.constructor.api().action(this.id + '/download').getBlob().then(response => {
            let file = new Blob([response], {
                type: fileType
            });
            let url = URL.createObjectURL(file);
            window.open(url,'_blank')
        });
    }
}
